import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth, useMe } from '@/lib/auth'
import { Spinner } from './spinner'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { token } = useAuth()
  const { user } = useMe()
  const location = useLocation()
  if (token === null || user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }
  return <>{children}</>
}
